import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { formTypes } from './Interfaces';
import { ChangeForm } from '../../Editor/CanvasFormService';
import { translate } from "../../Services/translation";
import { CANVAS_FORM_CHANGED, CANVAS_HOLES_CHANGED, } from '../../Rutab/RutabConstants';
import { updateHolePlacement, } from '../../Editor/HolePlacementHelper';
import { saveCanvasState } from '../../Actions/Rutab/HistoryActions';
export const availableForms = [
    { formName: translate('decal.shapemenu.type.none.label'), formKey: formTypes.None },
    { formName: translate('decal.shapemenu.type.arrowright.label'), formKey: formTypes.ArrowRight },
    { formName: translate('decal.shapemenu.type.arrowleft.label'), formKey: formTypes.ArrowLeft },
    { formName: translate('decal.shapemenu.type.triangle.label'), formKey: formTypes.Triangle },
    { formName: translate('decal.shapemenu.type.rhomb.label'), formKey: formTypes.RotatedSquare },
    { formName: translate('decal.shapemenu.type.oval.label'), formKey: formTypes.Oval },
    { formName: translate('decal.shapemenu.type.octagon.label'), formKey: formTypes.StopSign },
];
const availableHoles = [
    {
        id: 'none',
        src: '/images/editor/holeplacement_none.svg',
        label: translate('decal.shapemenu.holes.none.label'),
        worksWith: availableForms,
    },
    {
        id: 'left-right',
        src: '/images/editor/holeplacement_left_right.svg',
        label: translate('decal.shapemenu.holes.oneeachside.label'),
        worksWith: availableForms,
    },
    {
        id: 'corners',
        src: '/images/editor/holeplacement_middle.svg',
        label: translate('decal.shapemenu.holes.eachcorner.label'),
        worksWith: [formTypes.None],
    },
];
export const FormMenuContent = ({ canvas, canvasRef, }) => {
    const dispatch = useDispatch();
    const appSelector = useSelector((state) => state.decalEditor.selectedForm);
    const selectedHoles = useSelector((state) => state.decalEditor.holePlacement);
    const SelectForm = (canvasForm) => {
        ChangeForm(canvas, canvasRef, canvasForm);
        dispatch({
            type: CANVAS_FORM_CHANGED,
            payload: { canvasForm },
        });
        dispatch(saveCanvasState(canvas));
    };
    const selectHolePlacement = (placement) => {
        dispatch({
            type: CANVAS_HOLES_CHANGED,
            payload: { holePlacement: placement },
        });
        updateHolePlacement(canvas, placement);
        dispatch(saveCanvasState(canvas));
    };
    const isHoleCompatibleWithForm = (holeOption) => {
        if (!holeOption.worksWith)
            return false;
        if (Array.isArray(holeOption.worksWith)) {
            if (typeof holeOption.worksWith[0] === 'string') {
                return holeOption.worksWith.includes(appSelector.formKey);
            }
            return holeOption.worksWith.some((form) => form.formKey === appSelector.formKey);
        }
        return false;
    };
    return (_jsxs("div", { children: [_jsx("div", { className: "shape-options form-selector-content-guide", children: availableForms.map((form, index) => (_jsx("div", { children: _jsxs("div", { className: "shape-option", onClick: () => SelectForm(form), children: [_jsx("div", { className: "icon-text", children: _jsx("span", { children: form.formName }) }), _jsx("button", { className: `indicator ${appSelector.formKey == form.formKey ? 'active' : ''}`, children: appSelector.formKey == form.formKey ? translate('decal.button.choosen') : translate('decal.button.choose') })] }) }, index))) }), _jsxs("div", { className: "hole-container mt-1 hole-selector-content-guide", children: [_jsx("label", { className: "hole-label-main", children: translate('decal.shapemenu.selectholeplacement.header') }), _jsx("div", { className: "hole-grid", children: availableHoles.filter(isHoleCompatibleWithForm).map((option) => (_jsxs("div", { className: `hole-option ${selectedHoles === option.id ? 'selected' : ''}`, onClick: () => selectHolePlacement(option.id), children: [_jsx("img", { className: "hole-img", src: option.src, alt: option.label }), _jsx("span", { className: "hole-label", children: option.label })] }, option.id))) })] })] }));
};
